<template>
  <b-modal
    id="modal-cancel-pesanan"
    title="Request Pickup"
    :visible="open"
    :ok-disabled="loadingSubmit"
    cancel-variant="light"
    :cancel-disabled="loadingSubmit"
    ok-title="Kirim Request"
    @hidden="onHidden"
    @shown="onShown"
    @ok="onSubmit"
  >
    <p>Kurir akan pickup paket sesuai dengan informasi berikut:</p>

    <div class="font-weight-bold">
      Alamat pickup:
    </div>
    <div
      v-if="brand && brand.address"
      class="mb-1"
    >
      {{ brand.address.address }}
    </div>

    <div class="font-weight-bold">
      PIC
    </div>
    <div
      v-if="brand && brand.address"
      class="mb-1"
    >
      {{ brand.address.pickup_pic_name }} (+{{ brand.address.pickup_pic_phone }})
    </div>
    <small v-if="brand">Anda dapat mengubah informasi di atas melalui <router-link :to="`/brands/${brand.id}/edit`">
      pengaturan pickup.
    </router-link></small>

    <hr class="my-2">
    <validation-observer ref="simpleRules">
      <b-form-group
        label="Kendaraan*"
      >
        <validation-provider
          #default="{ errors }"
          name="Kendaraan"
          rules="required"
        >
          <b-form-select
            v-model="vehicle"
            :options="vehicleOptions"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
          <small
            v-if="data && data.delivery && data.delivery.courier === 'jnt' && errors.length === 0"
            class="text-muted"
          >
            J&T hanya mendukung pickup dengan sepeda motor.
          </small>
        </validation-provider>
      </b-form-group>

      <b-form-group
        label="Tanggal*"
      >
        <validation-provider
          #default="{ errors }"
          name="Tanggal"
          rules="required"
        >
          <b-form-datepicker
            v-model="date"
            locale="id"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <b-form-group
        label="Waktu*"
      >
        <validation-provider
          #default="{ errors }"
          name="Waktu"
          rules="required"
        >
          <b-form-timepicker
            v-model="time"
            locale="id"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <b-form-group
        v-if="data && data.delivery && data.delivery.courier !== 'jnt'"
        label="Instruksi khusus"
      >
        <validation-provider
          #default="{ errors }"
          name="Instruksi khusus"
        >
          <b-form-textarea
            v-model="instruction"
            placeholder="(Opsional)"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BFormTextarea,
  BFormGroup,
  BFormSelect,
  BFormDatepicker,
  BFormTimepicker,
} from 'bootstrap-vue'
import { mapActions, mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import moment from 'moment'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BFormTextarea,
    BFormGroup,
    BFormSelect,
    BFormDatepicker,
    BFormTimepicker,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    hide: {
      type: Function,
      default: null,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loadingSubmit: false,

      instruction: '',
      date: new Date(),
      time: '',
      vehicle: '',

      required,
    }
  },
  computed: {
    ...mapState('brand', ['brand']),
    vehicleOptions() {
      if (this.data && this.data.delivery && this.data.delivery.courier === 'jnt') {
        return [{ value: 'MOTOR', text: 'Sepeda Motor' }]
      }
      return [
        { value: 'MOTOR', text: 'Sepeda Motor' },
        { value: 'MOBIL', text: 'Mobil' },
      ]
    },
  },
  watch: {
    brand: {
      immediate: true,
      handler(val) {
        if (val && val.address) {
          this.time = this.brand.address.pickup_time
          this.vehicle = this.brand.address.pickup_vehicle

          // If courier is J&T and the default vehicle is MOBIL, reset it
          if (this.data && this.data.delivery && this.data.delivery.courier === 'jnt' && this.vehicle === 'MOBIL') {
            this.vehicle = ''
          }
        }
      },
    },
  },
  methods: {
    ...mapActions('transaction', ['onCancelOrder', 'requestPickup']),
    onHidden() {
      this.hide()

      this.name = ''
    },
    onShown() {},
    async onSubmit(e) {
      e.preventDefault()

      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.loadingSubmit = true

          this.requestPickup({
            id: this.data.id,
            data: {
              courier: this.data.delivery.courier,
              pickup_time: this.time.substr(0, 5),
              pickup_vehicle: this.vehicle,
              pickup_date: moment(this.date).format('DD-MM-YYYY'),
              instruction: this.instruction,
            },
          })
            .then(() => {
              this.hide()
              this.$emit('callback')
            })
            .catch(() => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Request pickup gagal!',
                  icon: 'BellIcon',
                  variant: 'danger',
                },
              })
            })
            .finally(() => {
              this.loadingSubmit = false
            })
        }
      })
    },
  },
}
</script>
